import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../_helpers/api';

import { Detail } from 'Components/Common/Detail/Detail';
import { Identificacion } from 'Components/Common/Detail/Identificacion';
import { Emisor } from 'Components/Common/Detail/Emisor';
import { FSEReceptor } from './FSEReceptor';
import { Resumen } from 'Components/Common/Detail/Resumen';
import { LoadingPlaceholder } from 'Components/Common/LoadingPlaceholder'

export const FSEDetail = () => {
  let { codigoGeneracion } = useParams();

  const [dte, setDTE] = useState({});
  const [loading, setLoading] = useState(true);

  const getDetails = () => {
    setLoading(true);
    api.get(`${api.getUri()}FSE/DTE/${codigoGeneracion}`).then((response) => {
      const data = response.data;
      if (Array.isArray(data) && data.length > 0) {
        setDTE(data.pop());
      } else if (data && typeof data === 'object') {
        setDTE(data);
      } else {
        console.error('Respuesta inesperada de la API:', response.data);
      }
      setLoading(false);
    }).catch((error) => {
      console.error('Error al obtener detalles del DTE:', error);
      setLoading(false);
    });
  };

  const onRefresh = () => {
    getDetails();
  }

  useEffect(() => {
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigoGeneracion]);

  return (
    <div>
      {loading ? (
        <LoadingPlaceholder />
      ) : dte && dte.dte ? (
        <Detail
          loading={loading}
          dte={dte}
          dteType={'FSE'}
          title={`DTE Factura de sujeto excluido (FSE): ${dte.dte.identificacion?.codigoGeneracion || ''}`}
          onRefresh={onRefresh}
          correoReceptor={dte.dte.sujetoExcluido?.correo}
        >
          <Identificacion
            identificacion={dte.dte.identificacion}
            firma={dte.firma}
            estatus={dte.estatus}
            validationResult={dte.validationResult}
            otherValidationsResult={dte.otherValidationsResult}
          />
          <Emisor emisor={dte.dte.emisor} codigoGeneracion={dte.dte.identificacion?.codigoGeneracion} />
          <FSEReceptor receptor={dte.dte.sujetoExcluido} codigoGeneracion={dte.dte.identificacion?.codigoGeneracion} />
          <Resumen resumen={dte.dte.resumen} codigoGeneracion={dte.dte.identificacion?.codigoGeneracion} />
        </Detail>
      ) : (
        <div>Error: No se pudieron cargar los detalles del DTE</div>
      )}
    </div>
  );
};
